exports.install = function (Vue, options) {
    Vue.prototype.promptPermissions = '权限不足，请先去绑定手机号！';
    Vue.prototype.LoginCode = function (code) { //app调用登录 登录
        let that = this;
        this.$store.commit('setApp', true);
        if (!that.USER()) { //微信登录
            this.$get('app_wxlogin', {
                code: code
            }).then(res => {
                layer.open({
                    content: res.msg,
                    time: 2,
                    skin: 'msg'
                });
                if (res.code == 200) {
                    res.data.token = res.data.refresh_token;
                    that.SET_USER(res.data);
                    // obj.success(res);
                    setTimeout(() => {
                        that.$router.replace("/m_index");
                    }, 2000)
                }
            }).catch(res => {
                layer.open({
                    content: res.message,
                    time: 2,
                    skin: 'msg'
                });
            })
        } else { //绑定微信
            this.$get('app_wxlogin', {
                code: code,
                member_id: that.USER().id,
            }).then(res => {
                layer.open({
                    content: res.msg,
                    time: 2,
                    skin: 'msg'
                });
                if (res.code == 200) {
                    res.data.token = res.data.refresh_token;
                    that.SET_USER(res.data);
                    // obj.success();
                    setTimeout(() => {
                        that.$router.replace("/m_index");
                    }, 2000)
                }

            }).catch(res => {
                layer.open({
                    content: res.message,
                    time: 2,
                    skin: 'msg'
                });
            })
        }
    };
    //分享
    Vue.prototype.wxShare = function (text, image, type) { //type=1朋友圈 2会话
        this.$store.commit('setApp', true);
        text = text ? text : '从麻醉的视角看医学';
        type = type ? type : 2;
        image = image ? image + '?x-oss-process=image/resize,limit_0,m_fill,w_100,h_100/quality,q_100' :
            'https://anesthesiavision.oss-cn-shanghai.aliyuncs.com/img/logoimg1.jpg';
        android.shareWx(window.location.href, "麻醉·眼界", text, image, type);
    };



    Vue.prototype.GET_Token = function (obj) { //授权
        // this.getShare();
        obj = obj ? obj : {
            success: function () {
                return false;
            }
        };
        obj.type = obj.type ? obj.type : 1; //1微信登录  2微信绑定
        let that = this;
        var browser = {
            versions: function () {
                var u = navigator.userAgent,
                    app = navigator.appVersion;
                return { //移动终端浏览器版本信息
                    trident: u.indexOf('Trident') > -1, //IE内核
                    presto: u.indexOf('Presto') > -1, //opera内核
                    webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
                    gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, //火狐内核
                    mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
                    ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
                    android: u.indexOf(' ') > -1 || u.indexOf('Linux') > -1, //android终端或uc浏览器
                    iPhone: u.indexOf('iPhone') > -1, //是否为iPhone或者QQHD浏览器
                    iPad: u.indexOf('iPad') > -1, //是否iPad
                    webApp: u.indexOf('Safari') == -1 //是否web应该程序，没有头部与底部
                };
            }(),
            language: (navigator.browserLanguage || navigator.language).toLowerCase()
        }
        if (browser.versions.mobile) { //判断是否是移动设备打开。browser代码在下面
            var ua = navigator.userAgent.toLowerCase(); //获取判断用的对象
            if (ua.match(/MicroMessenger/i) == "micromessenger") {
                //在微信中打开
                if (this.GetRequest().code) {
                    let data = {
                        code: this.GetRequest().code,
                    }
                    if (obj.type == 1 && !that.USER()) { //微信登录
                        this.$get('getUserInfo', data).then(res => {
                            layer.open({
                                content: res.msg,
                                time: 2,
                                skin: 'msg'
                            });
                            if (res.code == 200) {
                                res.data.token = res.data.refresh_token;
                                that.SET_USER(res.data);
                                obj.success(res);
                                setTimeout(() => {
                                    window.location.href = that.$VIEW_URL + "?v:" + Date.parse(new Date());
                                }, 2000)
                            } else {
                                let data_url = that.GetRequest().from;
                                data_url = data_url.slice(data_url.indexOf('#'), data_url.length);
                                that.$get('getAuthUrl', {
                                    url: this.$LIVE_URL + data_url
                                }).then(resT => {
                                    window.location.href = resT.data;
                                })
                            }
                        }).catch(res => {
                            layer.open({
                                content: res.message,
                                time: 2,
                                skin: 'msg'
                            });
                            let data_url = that.GetRequest().from;
                            data_url = data_url.slice(data_url.indexOf('#'), data_url.length)
                            that.$get('getAuthUrl', {
                                url: this.$LIVE_URL + data_url
                            }).then(resT => {
                                window.location.href = resT.data;
                            })
                        })
                    } else if (obj.type == 2 || that.USER()) { //微信绑定
                        data.member_id = that.USER().id;
                        this.$get('getUserInfo', data).then(res => {
                            layer.open({
                                content: res.msg,
                                time: 2,
                                skin: 'msg'
                            });
                            if (res.code == 200) {
                                res.data.token = res.data.refresh_token;
                                that.SET_USER(res.data);
                                // obj.success();
                            }
                            setTimeout(() => {
                                window.location.href = that.$VIEW_URL + "?v:" + Date.parse(new Date());
                            }, 2000)
                        }).catch(res => {
                            layer.open({
                                content: res.message,
                                time: 2,
                                skin: 'msg'
                            });
                        })
                    }
                } else {
                    this.$get('getAuthUrl', {
                        url: window.location.href
                    }).then(res => {
                        window.location.href = res.data;
                    })
                }

            } else {
                // this.$get('username', {}).then(res => {
                //     this.SET_USER(res.data)
                //     obj.success();
                // });
                layer.open({
                    content: "请用微信打开！",
                    time: true,
                    skin: "msg"
                });
            }
        } else {
            // this.$get('username', {}).then(res => {
            //     this.SET_USER(res.data)
            //     obj.success();
            // });
            layer.open({
                content: "请用微信打开！",
                time: true,
                skin: "msg"
            });
        }

    };

    Vue.prototype.GetRequest = function () {
        var url = location.search; //获取url中"?"符后的字串
        var theRequest = new Object();
        if (url.indexOf("?") != -1) {
            var str = url.substr(1);
            strs = str.split("&");
            for (var i = 0; i < strs.length; i++) {
                theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
            }
        }
        return theRequest;
    };
    Vue.prototype._isMobile = function () {
        //百度统计
        var _hmt = _hmt || [];
        (function () {
            var hm = document.createElement("script");
            hm.src = "https://hm.baidu.com/hm.js?8379155748b2097b694a2dcc7678ee2e";
            var s = document.getElementsByTagName("script")[0];
            s.parentNode.insertBefore(hm, s);
        })();



        let flag = navigator.userAgent.match(
            /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        );
        return flag;
    };
    // pc微信绑定
    Vue.prototype.WX_BINDING = function () {
        let that = this;
        $.ajax({
            type: 'get',
            url: this.$URL + 'pc_wxlogin',
            data: {
                code: this.GetRequest().code,
                member_id: this.USER().id,
            },
            success: function (ret) { //成功的回调函数
                layer.open({
                    content: ret.msg,
                    time: 2,
                    skin: 'msg'
                });
                if (ret.code == 200) { 
                    ret.data.token = ret.data.refresh_token;
                    that.SET_USER(ret.data); 
                }
                setTimeout(() => {
                    that.$router.replace("/");
                }, 2000)
                // setTimeout(() => {
                //     window.location.href = that.$VIEW_URL + "?v:" + Date.parse(new Date());
                // }, 2000)
            },
            error: function (e) {
                layer.open({
                    content: '网络出错',
                    time: 1,
                    skin: 'msg'
                });
            }
        });
    };
    // pc微信登录
    Vue.prototype.WX_LOGIN_BINDING = function () {
        let code = this.GetRequest().code;
        let state = this.GetRequest().state;
        let that = this;
        if (state.indexOf('member_id') > 0) { //绑定微信
            this.WX_BINDING();
            return false;
        }
        //微信登录
        $.ajax({
            type: 'get',
            url: this.$URL + 'pc_wxlogin',
            data: {
                code: code,
            },
            success: function (ret) { //成功的回调函数
                layer.open({
                    content: ret.msg,
                    time: 2,
                    skin: 'msg'
                });
                if (ret.code == 200) {
                    ret.data.token = ret.data.refresh_token;
                    that.SET_USER(ret.data);
                    console.log(ret.data,'1111111111');
                }
                setTimeout(() => {
                    that.$router.replace("/");
                }, 2000)
                // setTimeout(() => {
                //     window.location.href = that.$VIEW_URL + "?v:" + Date.parse(new Date());
                // }, 2000)
            },
            error: function (e) {
                layer.open({
                    content: '网络出错',
                    time: 1,
                    skin: 'msg'
                });
            }
        });

    };
    //获取用户数据
    Vue.prototype.USER = function () {
        console.log(localStorage.getItem("USER_111"),'USER');
        return localStorage.getItem("USER_111") ? JSON.parse(localStorage.getItem("USER_111")) : false //;false
    };
    //存储用户数据
    Vue.prototype.SET_USER = function (obj) {
        console.log(obj,'111111111');
        // if (obj) {   
            localStorage.setItem('USER_111', JSON.stringify(obj))
        // } else {
        //     localStorage.removeItem('USER_111')
        // }
    }
    // 退出登录
    Vue.prototype.REMOVE_USER = function () {
        // localStorage.clear();
        localStorage.removeItem("USER_111");
    }
    //判断是否登录
    Vue.prototype.JUDGE_USER = function (obj) {
        if (this.USER()) {
            this.REFRESH_USER();
        } else {
            layer.open({
                content: "请先登录账号~",
                time: true,
                skin: "msg"
            });
            setTimeout(() => {
                this.$router.replace('/');
            }, 1000)
        }
    }
    //获取实时用户数据
    Vue.prototype.REFRESH_USER = function () {
        let that = this;
        if (this.USER()) {
            this.$post('refresh', {
                mobile: that.USER().mobile
            }).then(res => {
                res.data.token = res.data.refresh_token;
                that.SET_USER(res.data);
            })
        }
    }
    //分享
    Vue.prototype.getShare = function (text, image, fun) {
        let that = this;
        text = text ? text : '从麻醉的视角看医学';
        image = image ? image + '?x-oss-process=image/resize,limit_0,m_fill,w_100,h_100/quality,q_100' :
            'https://anesthesiavision.oss-cn-shanghai.aliyuncs.com/img/logoimg1.jpg';
        fun = fun ? fun : () => { };
        this.$get('jsConfig', {
            param: ['updateAppMessageShareData', "updateTimelineShareData",],
            url: window.location.href,
        }).then(res => {
            // 分享配置
            that.$wx.config(res.data);
            // that.$wx.error(function(res){
            //     alert('出错了'+res.errMsg)
            // })
            that.$wx.ready(function () {
                // //分享到朋友圈
                that.$wx.updateTimelineShareData({
                    title: text,
                    link: window.location.href,
                    imgUrl: image,
                    success: function () {

                    },
                    trigger: function () {
                        fun();
                    },
                    fail: function(err) {
                        console.log('失败', err)
                    }
                });
                //分享给朋友
                that.$wx.updateAppMessageShareData({
                    title: "麻醉·眼界",
                    desc: text,
                    link: window.location.href,
                    imgUrl: image,
                    success: function () {

                    },
                    trigger: function () {
                        fun();
                    },
                    fail: function(err) {
                        console.log('失败', err)
                    }
                });

            })
        })

    };
    // 奖品名字
    Vue.prototype.giftType = function (type) {
        switch (type) {
            case 'T':
                return '闪开我要去学习'
                break;
            case 'A':
                return '点赞'
                break;
            case 'B':
                return '热气球'
                break;
            case 'C':
                return '孤寡'
                break;
            case 'D':
                return '划重点'
                break;
            case 'E':
                return '火箭'
                break;
            case 'F':
                return '撒花'
                break;
            case 'G':
                return '佩服三连'
                break;
            default:

        }
    }
    // 奖品名字
    Vue.prototype.MembershipGrade = function (type) {
        switch (type) {
            case 0:
                return '普通用户'
                break;
            case 1:
                return '普通会员'
                break;
            case 2:
                return '超级会员'
                break;
            default:
        }
    }
    //验证手机号
    Vue.prototype.validationPhone = function (num) {
        if (!(/^1[3456789]\d{9}$/.test(num))) {
            return false;
        } else {
            return true
        }
    }
    // 判断机型
    Vue.prototype.browser = function () {
        var browser = {
            versions: function () {
                var u = navigator.userAgent,
                    app = navigator.appVersion;
                return {
                    trident: u.indexOf('Trident') > -1, //IE内核
                    presto: u.indexOf('Presto') > -1, //opera内核
                    webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
                    gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, //火狐内核
                    mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
                    ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
                    android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1, //android终端
                    iPhone: u.indexOf('iPhone') > -1, //是否为iPhone或者QQHD浏览器
                    iPad: u.indexOf('iPad') > -1, //是否iPad
                    webApp: u.indexOf('Safari') == -1, //是否web应该程序，没有头部与底部
                    weixin: u.indexOf('MicroMessenger') > -1, //是否微信
                    qq: u.match(/\sQQ/i) == " qq" //是否QQ
                };
            }(),
            language: (navigator.browserLanguage || navigator.language).toLowerCase()
        }
        if (browser.versions.ios) {
            return true
        }
    }
    // 时间格式换算成秒
    Vue.prototype.formatSeconds = function (value) {
        var theTime = value.split(':'); // 需要转换的时间秒 
        var num = theTime[2] * 1;
        if ((theTime[1] * 1) > 0) {
            num += theTime[1] * 60;
        }
        if ((theTime[0] * 1) > 0) {
            num += theTime[0] * 3600;
        }
        return num;
    }
};


// WEBPACK FOOTER //
// ./src/assets/js/common.js